module.exports = __webpack_public_path__ + "img/health34_7-9-2021.9fbba061.jpg";